import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
  AxiosError,
} from 'axios';
import {
  VseSessionState,
  VseSessionToken,
} from './sessionTypes';
import {  
  useTypedSelector,
} from '../../store';
import * as VseAlert from '../alert';

const initalToken = {
  username: '',
  isAuthenticated: false,
  isAdmin: false,
  allowHandleIncoming: false,
  allowHandleOutoging: false,
} as VseSessionToken;

const initialState = {
  loading: 'idle',
  token: initalToken,
} as VseSessionState;

export const challenge = createAsyncThunk('session/challenge', async (_, thunkApi) => {
  try {
    const response = await axios.get<VseSessionToken>('api/identity/challenge');
    return response;
  } catch (err) {
    const error: AxiosError = err;
    //Not required to handle error
    return thunkApi.rejectWithValue(error);
  }
});

export const login = createAsyncThunk('session/login', async ({ userName, password }: { userName: string, password: string }, thunkApi) => {
  let data = new URLSearchParams();
  data.append('userName', userName);
  data.append('password', password);
  try {
    const response = await axios.post<VseSessionToken>('api/identity/login', data);
    return response;
  } catch (err) {
    const error: AxiosError = err;
    VseAlert.handleThunkError(thunkApi, error);
    return thunkApi.rejectWithValue(error);
  }
});

export const logout = createAsyncThunk('session/logout', async (_, thunkApi) => {
  try {
    const response = await axios.get('api/identity/logout');
    return response;
  } catch (err) {
    const error: AxiosError = err;
    //Not required to handle error
    return thunkApi.rejectWithValue(error);
  }
});

export const loginSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    reset: (state) => {
      state = Object.assign(state, initialState);
    },
    timeout: (state) => {
      state.loading = 'timeout';
    },
  },
  extraReducers: builder => {
    builder.addCase(login.pending, (state) => {
      state.loading = 'loading';
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.loading = 'succeeded';
      state.token = action.payload.data;
    });
    builder.addCase(login.rejected, (state) => {
      state.loading = 'failed';
      state.token = initalToken;
    });
    builder.addCase(challenge.pending, (state) => {
      state.loading = 'loading';
    });
    builder.addCase(challenge.fulfilled, (state, action) => {
      if (action.payload.data.isAuthenticated) {
        state.loading = 'succeeded';
        state.token = action.payload.data;
      } else {
        state.loading = 'pending';
        state.token = initalToken;
      }
    });
    builder.addCase(challenge.rejected, (state) => {
      state.loading = 'pending';
      state.token = initalToken;
    });
    builder.addCase(logout.pending, (state) => {
      state.loading = 'loading';
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.loading = 'loggedOut';
    });
    builder.addCase(logout.rejected, (state) => {
      state.loading = 'loggedOut';
    });
  },
});

export const { reset, timeout } = loginSlice.actions;

export default loginSlice.reducer;

export const useVseSessionState = (): VseSessionState => useTypedSelector(state => state.session);
